if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      // this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      // this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        // sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            // Handle different types of error descriptions
            let errorMessage;
            if (typeof response.description === 'string') {
              errorMessage = response.description;
            } else if (typeof response.description === 'object' && response.description !== null) {
              // If it's an object, try to extract a meaningful error message
              if (response.description.message) {
                errorMessage = response.description.message;
              } else if (Array.isArray(response.description)) {
                errorMessage = response.description.join(', ');
              } else {
                // Convert object to readable string
                errorMessage = Object.values(response.description).join(', ');
              }
            } else {
              errorMessage = 'An error occurred while adding the item to cart.';
            }
            
            this.handleErrorMessage(errorMessage);
            
            // Reset loading state immediately for errors
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            return;
          }

          // Add On Items
          const self = this; // Store reference to the ProductForm instance
          Shopify.moveAlong = function() {
        	  // If we still have requests in the queue, let's process the next one.
        	  if (Shopify.queue.length) {
        	    var request = Shopify.queue.shift();
        	    var data = 'id='+ request.variantId + '&quantity=' + request.variantQuantity
        	    $.ajax({
        	      type: 'POST',
                url: '/cart/add.js',
        	      dataType: 'json',
        	      data: data,
        	      success: function(res){
        	         Shopify.moveAlong();
        	     },
               error: function(){

                }
              });
            } else {
              // Only redirect to cart after successful add and all add-ons are processed
              setTimeout(() => {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
                self.querySelector('.loading-overlay__spinner').classList.add('hidden');
                location.href="/cart"
              }, 2500);
              return;
            }
          }
          Shopify.moveAlong();


          // check for Add Ons active OLD - No Variants
          // if($('.add-on-item.active').length){
          //
          //   Shopify.queue = [];
        	//   var addOnQuantity = $('.add-on-item.active').length;
        	//   $( '.add-on-item.active' ).each(function( index ) {
          //     var productVarID = $(this).attr('data-variant');
        	//     Shopify.queue.push({
        	//       variantId: productVarID,
        	//     });
          //   });
        	//   Shopify.moveAlong = function() {
          // 	  // If we still have requests in the queue, let's process the next one.
          // 	  if (Shopify.queue.length) {
          // 	    var request = Shopify.queue.shift();
          // 	    var data = 'id='+ request.variantId + '&quantity=1'
          // 	    $.ajax({
          // 	      type: 'POST',
          //         url: '/cart/add.js',
          // 	      dataType: 'json',
          // 	      data: data,
          // 	      success: function(res){
          // 	         Shopify.moveAlong();
          // 		       addOnQuantity += 1;
          // 	     },
          //        error: function(){
          //
          //         }
          //       });
          //     } else {
          //       return;
          //     }
          //   }
          //   Shopify.moveAlong();
          //
          // }
        })
        .catch((e) => {
          console.error(e);
          // Reset loading state for network errors
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
